import { Pressable, View } from 'react-native'

import { styled } from '~/utils/styled'

export const Root = styled(Pressable, theme => {
  return {
    base: {
      paddingTop: theme.paddingInsetThreepulse,
      paddingBottom: theme.paddingInsetThreepulse,
      paddingLeft: theme.paddingInsetThreepulse,
      paddingRight: theme.paddingInsetThreepulse,
      backgroundColor: theme.colorContainerFillDefault,
      borderColor: theme.colorContainerBorderDefault,
      borderWidth: theme.borderWidthQuarterpulse,
      borderRadius: theme.borderRadiusMediumcontainer,
      flex: 1,
      justifyContent: 'center',
    },
    variants: {
      isPressed: {
        true: {
          backgroundColor: theme.colorContainerFillPressed,
          borderColor: theme.colorContainerBorderPressed,
          borderWidth: theme.borderWidthQuarterpulse,
          borderRadius: theme.borderRadiusMediumcontainer,
        },
      },
      isDisabled: {
        true: {
          backgroundColor: theme.colorContainerFillDisabled,
          borderColor: theme.colorContainerBorderDisabled,
          borderWidth: theme.borderWidthQuarterpulse,
          borderRadius: theme.borderRadiusMediumcontainer,
        },
      },
      isSelected: {
        true: {
          backgroundColor: theme.colorContainerFillFocused,
          borderColor: theme.colorContainerBorderFocused,
          borderWidth: theme.borderWidthHalfpulse,
          borderRadius: theme.borderRadiusMediumcontainer,
        },
      },
    },
    compoundVariants: [
      {
        variants: {
          isSelected: true,
          isPressed: true,
        },
        css: {
          backgroundColor: theme.colorContainerFillFocused,
          borderColor: theme.colorContainerBorderFocused,
          borderWidth: theme.borderWidthHalfpulse,
          borderRadius: theme.borderRadiusMediumcontainer,
        },
      },
    ],
  }
})

export const Slot = styled(View, theme => {
  return {
    base: {
      backgroundColor: 'transparent',
      paddingLeft: theme.paddingInsetNone,
      paddingRight: theme.paddingInsetNone,
      paddingTop: theme.paddingInsetNone,
      paddingBottom: theme.paddingInsetNone,
    },
    variants: {},
  }
})
